<template>
  <BaseSpan>&copy; {{ year }} FOCUS, Kalkhoff & Urban Arrow</BaseSpan>
</template>

<script>
export default {
  name: 'Copyright',
  computed: {
    year() {
      return new Date().getFullYear()
    },
  },
}
</script>
